<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t1">Readers love</span></p>
<p class="p1"><span class="t2">D.W. M</span><span class="t3">ARCHWELL</span></p>
<p class="p2"><span class="t4">Even the Innocent</span></p>
<p class="p3">“I really, thoroughly enjoyed this book. I was somewhat blown away, but more out of the fact that I was pleasantly surprised just how much I enjoyed this one.”</p>
<p class="p4">—MM Good Book Reviews</p>
<p class="p2"><span class="t4">All That Heaven Will Allow</span></p>
<p class="p3">“This story honestly kept me turning the page, wanting to know the pair’s fate. Mr. Marchwell doesn’t fail to answer that… DW Marchwell’s seems a contemporary romance author well worth following.”</p>
<p class="p5">—GLBT Bookshelf</p>
<p class="p3">“This is a well written story with strong characters who will grab you from the beginning.”</p>
<p class="p5">—Literary Nymphs Reviews</p>
<p class="p3"><span class="t6">“Jimmy and Derek’s story is really quite romantic… I really liked it”</span></p>
<p class="p6">—The Blogger Girls</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?02a419c6